export default "__VITE_ASSET__05fHlZto__"